import { FC } from "react";
import { Box, Chip, useTheme } from "@mui/material";

type Props = {
    count: number;
    /** Quando informado, mostra um botão "Limpar" enquanto houver seleção. */
    onClear?: () => void;
};

/** Chip "N selecionado(s)" do wizard + botão Limpar opcional. */
const SelectionChip: FC<Props> = ({ count, onClear }) => {
    const theme = useTheme();

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Chip
                label={`${count} selecionado${count !== 1 ? "s" : ""}`}
                size="small"
                sx={{
                    backgroundColor: theme.palette.brand.cream,
                    border: `1px solid ${theme.palette.brand.heroBorder}`,
                    color: "primary.dark",
                    fontWeight: 600,
                    fontSize: "12px",
                    height: 24,
                }}
            />
            {count > 0 && onClear && (
                <Box
                    component="button"
                    type="button"
                    onClick={onClear}
                    sx={{
                        border: "none",
                        background: "none",
                        p: 0,
                        cursor: "pointer",
                        fontFamily: "inherit",
                        fontSize: "12px",
                        fontWeight: 600,
                        color: "text.secondary",
                        textDecoration: "underline",
                        "&:hover": { color: "primary.main" },
                        "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2, borderRadius: 4 },
                    }}
                >
                    Limpar
                </Box>
            )}
        </Box>
    );
};

export default SelectionChip;
